"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExpanderButton;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _Bars = _interopRequireDefault(require("@decisiv/iconix/lib/components/Bars"));

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledExpanderButton = _styledComponents.default.button.withConfig({
  displayName: "ExpanderButton__StyledExpanderButton",
  componentId: "sc-1bg58z1-0"
})(["background-color:transparent;border:1px solid transparent;color:", ";height:", ";width:", ";&:active,&:focus{outline:none;", ";}&:hover{background-color:", ";}"], (0, _toColorString.default)(_color.default.base.snowWhite), (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX), (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX), (0, _focusRingWithColor.default)(_constants.FOCUS_BORDER_COLOR), (0, _toColorString.default)(_color.default.base.alaskanHusky));

var ExpanderButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "ExpanderButton__ExpanderButtonContainer",
  componentId: "sc-1bg58z1-1"
})(["display:flex;height:", ";width:100%;"], (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX));

function ExpanderButton(_ref) {
  var onClick = _ref.onClick;
  return _react.default.createElement(ExpanderButtonContainer, null, _react.default.createElement(StyledExpanderButton, {
    type: "button",
    onClick: onClick
  }, _react.default.createElement(_Bars.default, null)));
}